module.exports = __webpack_public_path__ + "static/media/proj15_img5.d2a3223e.jpg";